import React from 'react';
import { ListItem, Box } from '@mui/material';

import { MenuItemLink } from '../MenuItemLink';
import { MenuArrow } from '../MenuArrow';
import styles from './menuListItem.styles';

const MenuListItem = ({ route, Icon, isExpandedRoute, handleClick }) => {
  return (
    <ListItem
      component={route.url ? MenuItemLink : Box}
      href={route.url}
      disablePadding
      onClick={() => handleClick(route)}
      sx={{
        ...styles.menuItem,
      }}
    >
      <Box sx={styles.menuItemInner}>
        {Icon && <Icon width={16} height={16} color="#2E2E30" />}
        {route?.title}
      </Box>
      {route?.options?.length && <MenuArrow expanded={isExpandedRoute} />}
    </ListItem>
  );
};

export default MenuListItem;
